import React from 'react';
import { Grid, Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setTab } from '../../reducers/UiReducer';
import SearchEngneBus from './SearchEngneBus';
import SearchEngineHotel from './SearchEngineHotel';
import SearchEngineHolidays from './SearchEngineHolidays';
import SearchEngineFlight from './SearchEngineFlight';
import SearchEngineFD from './SearchEngineFD';

const SlideCard = ({ img }) => {
	const dispatch = useDispatch();
	const { tab, topTab } = useSelector((state) => state.ui);
	return (
		<Grid container>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				style={{
					height: '65vh',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: 'yellow',
					backgroundImage: `url(${img})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
				}}></Grid>
		</Grid>
	);
};
export default SlideCard;
